export default __webpack_public_path__ + "static/media/ui_icon_comment_section.1f5a0f8d.svg";